import type { IconData } from '@stacksjs/iconify-core'

export const touchApp: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M454.423 278.957L328 243.839v-8.185a116 116 0 1 0-104 0V312h-24.418l-18.494-22.6a90.414 90.414 0 0 0-126.43-13.367a20.862 20.862 0 0 0-8.026 33.47L215.084 496H472V302.08a24.07 24.07 0 0 0-17.577-23.123M192 132a84 84 0 1 1 136 65.9V132a52 52 0 0 0-104 0v65.9a83.87 83.87 0 0 1-32-65.9m248 332H229.3L79.141 297.75a58.44 58.44 0 0 1 77.181 11.91l28.1 34.34H256V132a20 20 0 0 1 40 0v136.161l144 40Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default touchApp
